<script setup lang="ts">
import { useUserStore } from '@/stores/user'
import { useConfigStore } from '@/stores/config'
import { storeToRefs } from 'pinia'
import { useRoute } from 'vue-router'
import { routerPush } from '@/router'

import { computed, nextTick, onMounted, ref } from 'vue'

const emit = defineEmits(['toggle-dropdown'])

// interface Props {
//   displayParticipantInfo?: boolean
// }

// @todo : verify this needs to be deal with..
// const props = withDefaults(defineProps<Props>(), { displayParticipantInfo: true })

const userStore = useUserStore()
const configStore = useConfigStore()

// what is storeToRefs() for in this context?
const currentUser = storeToRefs(userStore)
const userAccount = ref(currentUser.account)

const route = useRoute()

const hasParticipant = ref(currentUser.haveParticipant)
const hasDependants = ref(currentUser.haveDependants)

const participant = ref(currentUser.participant)
const dependants = ref(currentUser.dependants)

const selectedParticipant = ref()
const participantList = computed(() => {
  let list = []
  list = dependants.value.map((dep) => {
    const fname = dep.preferred_name ?? dep.first_name
    const fullname = fname + ' ' + dep.last_name
    return {
      id: dep.id,
      name: fullname,
      number: dep.participant_number,
      me: false
    }
  })
  if (participant.value) {
    const fname = participant.value?.preferred_name ?? participant.value.first_name
    const fullname = fname + ' ' + participant.value.last_name
    list = [
      {
        id: participant.value.id,
        name: fullname,
        number: participant.value.participant_number,
        me: true
      },
      ...list
    ]
  }

  return list
})

function navigateToAccount() {
  routerPush('account')
}
function navigateToParticipant(id: number) {
  emit('toggle-dropdown', false)
  routerPush('participant-view', { participantId: `${id}` })
}
function navigateToFindParticipant() {
  emit('toggle-dropdown', false)
  routerPush('find-participant')
}

onMounted(async () => {
  configStore.loadAppProducts()

  nextTick()
  // are we on the participant page .. and if so .. what participant id?
  if (route?.name === 'participant-view' && route.params?.participantId) {
    const currentPid = Number(route.params?.participantId)
    const selected = participantList.value.find((p) => {
      if (p.id === currentPid) {
        return p.name
      }
    })
    if (selected) {
      selectedParticipant.value = selected
    }
  }
})
</script>
<template>
  <v-card class="px-2 py-2 my-2">
    <v-card-title>{{ userAccount?.first_name }} {{ userAccount?.last_name }}</v-card-title>
    <v-card-text>
      <v-btn
        variant="text"
        class="pa-0 text-left no-uppercase"
        @click="navigateToAccount()"
        :class="{ 'non-clickable': route.name === 'account' }"
      >
        <h3 class="mb-0 d-inline-flex align-center">
          <v-icon
            class="text-lightblue"
            icon="mdi-pencil-outline"
            size="small"
            v-tooltip="'View Account'"
          />
          <span class="ml-1">Account</span>
        </h3>
      </v-btn>

      <p>{{ userAccount?.email }}</p>

      <v-btn
        variant="text"
        class="pa-0 text-left no-uppercase"
        @click="navigateToAccount()"
        :class="{ 'non-clickable': route.name === 'account' }"
      >
        <h3 class="mb-0 d-inline-flex align-center">
          <v-icon
            class="text-lightblue"
            icon="mdi-account-plus"
            v-tooltip="'Add Participant Account'"
            size="small"
          />
          <span class="ml-1"> Participant(s)</span>
        </h3>
      </v-btn>

      <template v-if="hasParticipant || hasDependants">
        <p>Select participant</p>

        <v-select
          item-title="name"
          :items="participantList"
          label="Select participant to view"
          v-model="selectedParticipant"
        >
          <template v-slot:item="{ props, item }">
            <v-list-item
              v-bind="props"
              :subtitle="item.raw.number"
              @click="navigateToParticipant(item.raw.id)"
              :class="item.raw.me ? 'text-orange' : ''"
            ></v-list-item>
          </template>
        </v-select>
      </template>

      <template v-if="!hasDependants">
        <div class="justify-left ma-0">
          <p>It looks like you don't have any dependants associated with your account.</p>

          <p>Use the Find/Create Participant Icon above to add a dependant</p>
        </div>
      </template>
    </v-card-text>
    <v-card-actions class="d-flex align-center">
      <div class="d-flex flex-column align-content-center mx-auto">
        <v-btn
          variant="elevated"
          class="p-4 bg-orange text-white text-bold"
          @click="navigateToFindParticipant()"
          alt="Attach / Create Participant"
          prepend-icon="mdi-account-plus"
        >
          Add Participant
        </v-btn>
      </div>
    </v-card-actions>
  </v-card>
</template>
